import { Route, Routes } from 'react-router-dom';

import { paths } from 'data/routes';

import { DefaultLayout } from 'layouts/DefaultLayout';

import { List } from './components/List';
import { MyLists } from './components/MyLists';

export function SelectionsPage(): React.ReactElement {
  return (
    <DefaultLayout withHeader isNested>
      <Routes>
        <Route path={paths.myLists} element={<MyLists />} />

        <Route path="my-lists/list/:id/*" element={<List />} />
      </Routes>
    </DefaultLayout>
  );
}
